import { getNewsletters, getNewsletter, saveNewsletter, saveNewsletterTargets, getReportState } from '../../../shared/data-services/newsletter-service';
import { getNewsletterStates } from '../../../shared/data-services/newsletter-state-service';
import { getCustomers } from '../../../shared/data-services/consumer-service';
import { getNewsletterTypes } from '../../../shared/data-services/newslettertype-service';
import { getEmployeePositions } from '../../../shared/data-services/employee-position-service';
import { getAirports } from '../../../shared/data-services/airport-service';
import { getAssessments, getAssessmentReportByNewsletterId , getAssessmentReportDetailByNewsletterId } from '../../../shared/data-services/assessment-service';
import { getNewsLetterContentTypes } from '../../../shared/data-services/newsletter-content-type-service';
import { getActivityCampaign, saveDataRegisterActivity } from '../../../shared/data-services/campaign-service';


export async function getAllActivityCampaign (EmployeeId, companyId){
  const data = await getActivityCampaign(EmployeeId, companyId);
  return data || [ ];
};

export async function getSelectedNewsletter (id){
  const data = await getNewsletter(id);
  return data;
};

export async function getResportStateData (id){
  const data = await getReportState(id);
  return data || [ ];
};

export async function saveSelectedNewsletter ( 
          id,
          code,
          name,
          customerId,
          newsletterStateId,
          date,
          newsletterTypeId,
          assessmentId,
  ){
  const parameters = {
        id,
        code,
        name,
        customerId,
        newsletterStateId,
        date,
        newsletterTypeId,
        assessmentId,
  }

  const data = await saveNewsletter(parameters);
  return data;
};

export async function getAllNewsletterStates (){
  
  const data = await getNewsletterStates();
  return data;
};

export async function getAllCustomers (companyId){
  
  const data = await getCustomers(companyId);
  return data;
};

export async function getAllNewsletterTypes (companyId){
  
  const data = await getNewsletterTypes(companyId);
  return data;
};

export async function getAllEmployeePositions (companyId){
  
  const data = await getEmployeePositions(companyId);
  return data;
};

export async function getAllAirports (companyId){
  
  const data = await getAirports(companyId);
  return data;
};


export async function saveAllNewsletterTargets (params,OnlyEnabledCustomerEmployees,companyId){
  const data = await saveNewsletterTargets(params, OnlyEnabledCustomerEmployees,companyId);
  return data;
};

export async function getListAssessment (companyId){
  const data = await getAssessments(companyId);
  return data || [ ];
};



export async function getAllNewsLetterContentTypes (){
  
  const data = await getNewsLetterContentTypes();
  return data;
};

export async function getAssessmentReportByNewsletterIdData (id){
  const data = await getAssessmentReportByNewsletterId(id);
  return data || [ ];
};

export async function getAssessmentReportDetailByNewsletterIdData (id){
  const data = await getAssessmentReportDetailByNewsletterId(id);
  return data || [ ];
};

export async function saveRegisterActivity (employeeId, activityId, personResponsibleId){
  const data = await saveDataRegisterActivity(employeeId, activityId, personResponsibleId);
  return data || [ ];
};
